import React, { FormEvent, useEffect, useState } from "react";
import {
    StyledLoginPage,
    StyledLoginPageContent,
    StyledLoginFormOuterContainer,
    StyledLoginForm,
    StyledLoginFormContainer,
    StyledLoginFormAlpsLogo,
    StyledAlpsLogo,
    StyledLoginFormHeader,
    StyledFormLoginContentContainer,
    StyledEmailField,
    StyledLoginInput,
    StyledPassField,
    StyledForgotPass,
    StyledForgotPassAnchor,
    StyledLoginButtonContainer,
    StyledLoginButton,
    StyledLoginLoaderImage,
    StyledContactUsForm,
    StyledContactUsAnchor,
    StyledIHS,
    StyledIHC,
    StyledIHH,
    StyledIH,
    StyledCarousel,
    StyledLoginErrorToast,
    StyledErrorToastHighlight,
    StyledErrorToastContent,
    StyledErrorToastIcon,
    StyledErrorToastMsg,
    StyledErrorToastRemoveIcon,
    StyledMainWrapper,
    StyledSSOButton,
    StyledPassButton,
    StyledButtonContainer,
    StyledSeparator,
    StyledSeparateSSOButton,
    StyledChangepasswrodMsg,
    StyledChangesPasswrodToast,
    StyledChangesPasswrodToastIcon,
    StyledChangesPasswrodToastHighlight
} from "./style";
import { CarouselBody, LeftArrow, RightArrow } from "./components";
import { searchAwardEurope, bestSoftwareAward, searchSoftwareAward, searchAwardUS, LoaderImg, } from "../../../app/icons";
import { useDispatch, useSelector } from "react-redux";
import {
    callToCheckSSOLogin,
    setLogginIn,
    callToUserLogin,
    callToUserLoginWithTenant,
    setErrMsg
} from "../../../user_account/ducks/actions";
import { ApplicationStateInterface } from "../../../../src/app/duck/types";
import {
    StyledCaretSpan,
    StyledChangeBodyContainer,
    StyledChangeTenantMultiWrapper,
    StyledChangeTenantMultipleContainer,
    StyledClearBoth,
    StyledContact,
    StyledContinueButton,
    StyledContinueButtonWrapper,
    StyledCustomMultipleDropDown,
    StyledDropDownButton,
    StyledMenuItemsLogin,
    StyledMultiLayerIcon,
    StyledMultipleDropDown,
    StyledMultoDropUl,
    StyledSelectAccountTitle,
    StyledSelectDropDown,
    StyledSelectDropDownWrapper,
    StyledTenantCodeList,
    StyledValueSpan
} from "../changeTenant/style";
import { capitalizeFirstLetter } from "./../../ducks/utils";
import { isUndefined } from "lodash";
import { TenantListInterface } from "../../../../src/user_account/ducks/types";
import { googleTagManagerDataLayer } from "../../../../src/app/duck/utils";

const LoginPage = () => {
    const dispatch = useDispatch();
    const [showErrMsg, setShowErrMsg] = useState<boolean>(false);
    const [showLoaderLogin, setShowLoaderLogin] = useState<boolean>(false);
    const [showLoaderSSO, setShowLoaderSSO] = useState<boolean>(false);

    const onErrorClose = () => {
        setShowErrMsg(false);
        dispatch(setErrMsg(""));
    };
    const onChangePasswordClose = () => {
        setIsChangePassword(false);
    };

    const onNextButtonClicked = () => {
        if (email === "" || !email.match(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/i)) {
            dispatch(setErrMsg("Invalid Credentials"));
        } else {
            setShowErrMsg(false);
            dispatch(setErrMsg(undefined));
            setShowLoaderLogin(false);
            setShowLoaderSSO(true);
            dispatch(setLogginIn(true));
            dispatch(callToCheckSSOLogin({ email }));
        }
    };

    const onLoginButtonClicked = () => {
        if (email === "" || pass === "" || !email.match(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/i)) {
            dispatch(setErrMsg("Invalid Credentials"));
        } else {
            setShowErrMsg(false);
            dispatch(setErrMsg(undefined));
            setShowLoaderLogin(true);
            setShowLoaderSSO(false);
            dispatch(setLogginIn(true));
            dispatch(callToUserLogin({ email, password: pass }));
        }
    };

    const handlePassClick = () => {
        setPassField(true);
        setShowErrMsg(false);
        dispatch(setErrMsg(undefined));
    };

    const [loggingIn] = useSelector((state: ApplicationStateInterface) => [state.userAccount.loggingIn]);
    const [isSSOUser] = useSelector((state: ApplicationStateInterface) => [state.userAccount.ssoUser]);
    const [tenantList] = useSelector((state: ApplicationStateInterface) => [state.userAccount.tenantList]);
    const [userId] = useSelector((state: ApplicationStateInterface) => [state.userAccount.userId]);
    const [errMsg] = useSelector((state: ApplicationStateInterface) => [state.userAccount.errMsg]);
    const [cogClientID] = useSelector((state: ApplicationStateInterface) => [state.userAccount.cogClientID]);
    const [cogAPI] = useSelector((state: ApplicationStateInterface) => [state.userAccount.cogAPI]);
    const [intmdID] = useSelector((state: ApplicationStateInterface) => [state.userAccount.intmdID]);
    const awardList: [string[]] = [[searchAwardEurope, bestSoftwareAward, searchSoftwareAward, searchAwardUS]];

    const awardsListCount: boolean = awardList.length > 1 ? true : false;

    const [arrowValue, setArrowValue] = useState<number>(0);
    const [arrowVisible, setArrowVisible] = useState<boolean>(awardsListCount);
    const [leftArrowDisable, setLeftArrowDisable] = useState<boolean>(true);
    const [rightArrowDisable, setRightArrowDisable] = useState<boolean>(false);
    const [isChangePassword, setIsChangePassword] = useState<boolean>(false);
    const [multiTenant, setMultiTenant] = useState<boolean>(false);
    const [email, setEmail] = useState<string>("");
    const [pass, setPass] = useState<string>("");
    const clickArrow = (param: string) => {
        if (param === "dec") {
            setArrowValue(arrowValue - 1);
        } else {
            setArrowValue(arrowValue + 1);
        }
    };

    useEffect(() => {
        setLeftArrowDisable(arrowValue ? false : true);
        setRightArrowDisable(arrowValue === awardList.length - 1 ? true : false);
    }, [arrowValue]);

    useEffect(() => {
        if (errMsg) {
            setShowErrMsg(true);
        }
    }, [errMsg]);

    useEffect(() => {
        setArrowVisible(awardsListCount);
    }, []);

    useEffect(() => {
        if (isSSOUser === true && cogAPI && cogClientID) {
            window.location.href =
                `${cogAPI}/authorize?idp_identifier=${email.split("@")[1]}&redirect_uri=${window.location.origin}/sso/callback/&response_type=code&client_id=${cogClientID}&scope=openid`;
        } else if (isSSOUser === false) {
            setPassField(true);
        }
    }, [isSSOUser, cogAPI, cogClientID]);

    useEffect(() => {
        if (!isUndefined(tenantList)) {
            setSelectedTenant(tenantList[0]);
            setMultiTenant(true);
        }
    }, [tenantList]);

    useEffect(() => {
        googleTagManagerDataLayer("set", [], { user_id: userId });
    }, [userId]);

    useEffect(() => {
        const script = document.createElement("script");
        script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.GOOGLE_CAPTCHA_SITE_KEY}`;
        document.body.appendChild(script);
    }, []);
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const changePassword = queryParams.get("cp");
        if (changePassword === "true") {
            setIsChangePassword(true);
        }
    }, []);
    const [dropdownClick, setDropDownClick] = useState<boolean>(false);
    const [passField, setPassField] = useState<boolean>(false);
    const [selectedTenant, setSelectedTenant] = useState<TenantListInterface>(
        tenantList ? tenantList[0] : { id: "", display_name: "" }
    );

    const onContinueButtonClicked = () => {
        dispatch(callToUserLoginWithTenant({ tenant_code: selectedTenant.id, user_id: userId, intmd_id: intmdID }));
    };

    const submitForm = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        !passField ? onNextButtonClicked() : onLoginButtonClicked();
    };

    return !multiTenant ? (
        <StyledMainWrapper>
            <StyledLoginPage>
                <StyledLoginPageContent passField={passField}>
                    <StyledLoginFormOuterContainer>
                        <StyledLoginFormContainer>
                            <StyledLoginFormAlpsLogo id="login-form-alps-logo">
                                <StyledAlpsLogo />
                            </StyledLoginFormAlpsLogo>
                            <StyledLoginFormHeader showErrMsg={showErrMsg}>Login</StyledLoginFormHeader>
                            <StyledFormLoginContentContainer>
                                {showErrMsg && (
                                    <StyledLoginErrorToast>
                                        <StyledErrorToastHighlight />
                                        <StyledErrorToastContent>
                                            <StyledErrorToastIcon />
                                            <StyledErrorToastMsg className="login-err-msg" id="error_toast_message" dangerouslySetInnerHTML={{ __html: errMsg || "" }} />
                                            <StyledErrorToastRemoveIcon id="error_toast_remove_icon" onClick={onErrorClose} />
                                        </StyledErrorToastContent>
                                    </StyledLoginErrorToast>
                                )}
                                {isChangePassword && <StyledChangesPasswrodToast>
                                    <StyledChangesPasswrodToastHighlight />
                                    <StyledErrorToastContent>
                                        <StyledChangesPasswrodToastIcon />
                                        <StyledChangepasswrodMsg>
                                            Your password has been updated successfully. Please use the new password to log in.
                                        </StyledChangepasswrodMsg>
                                        <StyledErrorToastRemoveIcon onClick={onChangePasswordClose} />
                                    </StyledErrorToastContent>
                                </StyledChangesPasswrodToast>}
                                <StyledLoginForm name="formLogin" onSubmit={(e: FormEvent<HTMLFormElement>) => submitForm(e)}>
                                    <StyledEmailField>
                                        <StyledLoginInput
                                            type="email"
                                            name="email"
                                            autoFocus={true}
                                            placeholder="Email"
                                            autoComplete="off"
                                            onChange={(e) => {
                                                setEmail(e.target.value.toLowerCase());
                                            }}
                                        />
                                    </StyledEmailField>

                                    {passField && (
                                        <StyledPassField>
                                            <StyledLoginInput
                                                type="password"
                                                name="password"
                                                placeholder="Password"
                                                autoComplete="off"
                                                onChange={(e) => {
                                                    setPass(e.target.value);
                                                }}
                                            />
                                        </StyledPassField>
                                    )}
                                    {passField && (
                                        <StyledForgotPass id="login-forgot-pwd-btn">
                                            <StyledForgotPassAnchor href="/forgotpassword">Forgot Password?</StyledForgotPassAnchor>
                                        </StyledForgotPass>
                                    )}
                                    {!passField ?
                                        <StyledButtonContainer>
                                            <StyledPassButton id="login-with-password-btn" type="button" onClick={handlePassClick} btn_type="login">
                                                <span>Login With Password</span>
                                            </StyledPassButton>

                                            {!loggingIn ? <StyledSSOButton id="login-with-sso-btn" type="submit" loggingIn={loggingIn} disabled={loggingIn} />
                                                : (
                                                    <StyledSSOButton loggingIn={loggingIn} disabled={loggingIn}>
                                                        <StyledLoginLoaderImage src={LoaderImg} alt="Please wait" />
                                                    </StyledSSOButton>
                                                )
                                            }
                                        </StyledButtonContainer> :
                                        <>
                                            <StyledLoginButtonContainer id="login-button-container">
                                                <StyledLoginButton id="login-btn" type="submit" loggingIn={loggingIn} disabled={loggingIn}>
                                                    {!loggingIn || !showLoaderLogin ? (
                                                        <span>Log In</span>
                                                    ) : (
                                                        <StyledLoginLoaderImage src={LoaderImg} alt="Please wait" />
                                                    )}
                                                </StyledLoginButton>
                                            </StyledLoginButtonContainer>
                                            <StyledSeparator>
                                                or
                                            </StyledSeparator>
                                            <StyledLoginButtonContainer>
                                                {!loggingIn || !showLoaderSSO ? <StyledSeparateSSOButton
                                                    id="login-with-sso-btn"
                                                    type="button"
                                                    onClick={onNextButtonClicked}
                                                    loggingIn={loggingIn}
                                                    disabled={loggingIn}
                                                />
                                                    : (
                                                        <StyledSeparateSSOButton loggingIn={loggingIn} disabled={loggingIn}>
                                                            <StyledLoginLoaderImage src={LoaderImg} alt="Please wait" />
                                                        </StyledSeparateSSOButton>
                                                    )
                                                }
                                            </StyledLoginButtonContainer>
                                        </>
                                    }
                                </StyledLoginForm>
                            </StyledFormLoginContentContainer>
                            <StyledContactUsForm id="login-form-contact-us">
                                <StyledContactUsAnchor href="javascript: zE('webWidget', 'show'); zE('webWidget', 'open');">
                                    Contact Us
                                </StyledContactUsAnchor>
                            </StyledContactUsForm>
                        </StyledLoginFormContainer>
                    </StyledLoginFormOuterContainer>
                    <StyledIHS>
                        <StyledIHC>
                            <StyledIHH id="industry-honors-header">
                                ALPS&trade; uses AI to drive efficiency, speed and superior results in SEO and content marketing
                            </StyledIHH>
                            <StyledIH id="awards-and-recognition-text">Industry Honors</StyledIH>
                            <StyledCarousel>
                                {arrowVisible && <LeftArrow clickArrow={clickArrow} disable={leftArrowDisable} param={"dec"} />}
                                <CarouselBody awardsListIndex={arrowValue} />
                                {/* <img src={searchSoftwareAward} /> */}
                                {arrowVisible && <RightArrow clickArrow={clickArrow} disable={rightArrowDisable} param={"inc"} />}
                            </StyledCarousel>
                        </StyledIHC>
                    </StyledIHS>
                </StyledLoginPageContent>
            </StyledLoginPage>
        </StyledMainWrapper>
    ) : (
        <StyledChangeBodyContainer>
            <StyledChangeTenantMultipleContainer>
                <StyledMenuItemsLogin>
                    <StyledContact href="javascript: zE('webWidget', 'show'); zE('webWidget', 'open');">Contact</StyledContact>
                </StyledMenuItemsLogin>
                <StyledChangeTenantMultiWrapper>
                    <StyledMultiLayerIcon />
                    <StyledMultipleDropDown>
                        <StyledSelectAccountTitle>Select an account from the list</StyledSelectAccountTitle>
                        <StyledSelectDropDown>
                            <StyledSelectDropDownWrapper>
                                <StyledDropDownButton
                                    className="btn btn-default dropdown-toggle alignBtnDropdown custom_multiple"
                                    id="change-tenant-open-dropdown-btn"
                                    data-toggle="dropdown"
                                    onClick={() => setDropDownClick((prev: boolean) => !prev)}
                                >
                                    <StyledValueSpan className="value">
                                        {capitalizeFirstLetter(selectedTenant.display_name as string)}
                                    </StyledValueSpan>
                                    <StyledCaretSpan className="caret" />
                                    <StyledClearBoth />
                                </StyledDropDownButton>
                                {dropdownClick && (
                                    <StyledCustomMultipleDropDown>
                                        <StyledMultoDropUl role="menu" aria-labelledby="menu1">
                                            {tenantList?.map((item: TenantListInterface, index) => {
                                                return (
                                                    <StyledTenantCodeList
                                                        key={index}
                                                        onClick={() => {
                                                            setSelectedTenant(tenantList[index]);
                                                            setDropDownClick((prev: boolean) => !prev);
                                                        }}
                                                    >
                                                        {capitalizeFirstLetter(item.display_name as string)}
                                                    </StyledTenantCodeList>
                                                );
                                            })}
                                        </StyledMultoDropUl>
                                    </StyledCustomMultipleDropDown>
                                )}
                            </StyledSelectDropDownWrapper>
                            <StyledContinueButtonWrapper>
                                <StyledContinueButton id="change-tenant-continue-btn" onClick={() => onContinueButtonClicked()}>Continue</StyledContinueButton>
                            </StyledContinueButtonWrapper>
                        </StyledSelectDropDown>
                    </StyledMultipleDropDown>
                </StyledChangeTenantMultiWrapper>
            </StyledChangeTenantMultipleContainer>
        </StyledChangeBodyContainer>
    );
};

export default LoginPage;
